import {Stack, Typography} from "@mui/material";
import type {NamePartResolver} from "../../../../../../sdo/Resolver.ts";
import {MatchModeRow, F, SummaryPill, SummaryPillRow, rowSx, hintSx, set, type ResolverEditorProps} from "./ResolverUtils.tsx";

function NamePartEditor({draft, editing, onChange}: ResolverEditorProps & { draft: NamePartResolver }) {
    if (!editing) {
        return (
            <Stack direction="column" spacing={0.5} sx={{alignItems: "center", width: "100%"}}>
                <SummaryPillRow>
                    <SummaryPill label="Prefix" value={draft.prefix}/>
                    <SummaryPill label="First" value={draft.firstName}/>
                    <SummaryPill label="Middle" value={draft.middleName}/>
                </SummaryPillRow>
                <SummaryPillRow>
                    <SummaryPill label="Last" value={draft.lastName}/>
                    <SummaryPill label="Suffix" value={draft.suffix}/>
                    <SummaryPill label="Short Name" value={draft.shortName}/>
                </SummaryPillRow>
                <SummaryPillRow>
                    <SummaryPill label="Nickname" value={draft.nickname}/>
                </SummaryPillRow>
            </Stack>
        );
    }

    const upd = (key: string, value: unknown) => set(draft, key, value, onChange);
    return (
        <Stack direction="column" spacing={1} alignItems="center">
            <MatchModeRow draft={draft} editing={editing} onChange={onChange}/>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.prefix} placeholder="Prefix" onChange={(v) => upd("prefix", v)} width="90px"/>
                <F value={draft.firstName} placeholder="First Name" onChange={(v) => upd("firstName", v)} width="150px"/>
                <F value={draft.middleName} placeholder="Middle Name" onChange={(v) => upd("middleName", v)} width="150px"/>
            </Stack>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.lastName} placeholder="Last Name" onChange={(v) => upd("lastName", v)} width="150px"/>
                <F value={draft.suffix} placeholder="Suffix" onChange={(v) => upd("suffix", v)} width="90px"/>
                <F value={draft.shortName} placeholder="Short Name" onChange={(v) => upd("shortName", v)} width="150px"/>
            </Stack>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.nickname} placeholder="Nickname" onChange={(v) => upd("nickname", v)} width="150px"/>
            </Stack>
            <Typography sx={hintSx}>Use a blank in any field to accept any value</Typography>
        </Stack>
    );
}

export default NamePartEditor;
